import { TableCell, TableRow, Typography, IconButton, useMediaQuery, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { glb_sv } from 'src/utils';
import Label from 'src/components/label';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuActionsItem from './MenuActionItem';
const Item2 = ({
    item,
    index,
    STATUS_COLOR,
    dataRef,
    setVisibleApprove,
    setVisibleOpenChecking,
    setVisibleReject,
    openRowIndex,
    setOpenRowIndex,
    setVisibleOpenAdminTakeDevice,
    setVisibleOpenAdminPutDevice
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const user = glb_sv.userInfo;
    const isAdmin = user.group_user == '1' || user.group_user == '2' || user.group_user == '4';
    return (
        <>
            <TableRow onClick={() => setOpenRowIndex(openRowIndex === index ? null : index)} hover key={index}>
                <TableCell padding="checkbox" />
                <TableCell padding="checkbox" />
                <TableCell padding="checkbox">{index + 1}</TableCell>
                <TableCell>
                    <Label color={STATUS_COLOR[item.status]}>{item.status_name}</Label>
                </TableCell>
                <TableCell style={{ minWidth: '200px' }} align="left">
                    <Stack display={'flex'} flexDirection={'row'} alignItems={'center'} gap={2}>
                        <img
                            src={
                                item.img_device
                                    ? glb_sv.urlGetProductImage(item.img_device)
                                    : glb_sv.urlGetProductImage(item.pic_device)
                            }
                            alt={item.device_nm}
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: 4,
                                objectFit: 'cover',
                            }}
                        />
                        <Typography variant="subtitle2">{glb_sv.convertMultipleLanguages(item.device_nm)}</Typography>
                    </Stack>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="info">
                        <Stack display={'flex'} flexDirection={'column'}>
                            <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                {t('cabinet')}: {item.cabinet_nm}
                            </Typography>
                            <Typography variant="subtitle3" noWrap>
                                {t('drawer')}: {item.drawer_nm}
                            </Typography>{' '}
                            <Typography variant="subtitle3" noWrap>
                                {t('cell')}: {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                            </Typography>
                        </Stack>
                    </Typography>
                </TableCell>
                <TableCell>{item.device_cd && item.device_cd}</TableCell>
                <TableCell>{item.create_time && glb_sv.formatDate(item.create_time, 'YYYYMMDDHHmmss')}</TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_request_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_approve_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    {item.approve_or_reject_date && glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="info">
                        {item.approve_or_reject_date ? (
                            <Stack display={'flex'} flexDirection={'column'}>
                                <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                    {t('cabinet')}: {item.cabinet_nm_take}
                                </Typography>
                                <Typography variant="subtitle3" noWrap>
                                    {t('drawer')}: {item.drawer_nm_take}
                                </Typography>{' '}
                                <Typography variant="subtitle3" noWrap>
                                    {t('cell')}: {`[ ${item?.cell_lc_take?.row} : ${item?.cell_lc_take?.column} ]`}
                                </Typography>
                            </Stack>
                        ) : (
                            <>---</>
                        )}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                         <TableCell>{item.user_take_date && glb_sv.formatDate(item.user_take_date, 'YYYYMMDDHHmmss')}</TableCell>
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note_reject}
                    </Typography>
                </TableCell>

                <TableCell
                    padding="checkbox"
                    sx={{
                        position: 'sticky',
                        right: 0,
                        backgroundColor: '#f4f6f8',
                        zIndex: 3,
                    }}
                >
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                        }}
                    >
                        <MoreHorizIcon />
                    </IconButton>
                    <MenuActionsItem
                        {...{
                            item,
                            isAdmin,
                            dataRef,
                            setVisibleOpenChecking,
                            setVisibleReject,
                            setVisibleOpenAdminTakeDevice,
                            setVisibleOpenAdminPutDevice
                        }}
                        open={openMenu}
                        anchorEl={anchorEl}
                        onClose={(e) => {
                            e.stopPropagation();
                            setAnchorEl(null);
                        }}
                    />
                </TableCell>
            </TableRow>
        </>
    );
};

export default Item2;
